var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPytorch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 310,
    viewBox: "0 0 256 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.281 90.1064C268.573 140.398 268.573 221.075 218.281 271.716C169.037 322.008 88.0109 322.008 37.719 271.716C-12.573 221.424 -12.573 140.398 37.719 90.1064L127.825 0V45.0532L119.443 53.4352L59.7217 113.157C22.0027 150.177 22.0027 210.947 59.7217 248.666C96.7422 286.385 157.512 286.385 195.231 248.666C232.95 211.645 232.95 150.876 195.231 113.157L218.281 90.1064ZM173.228 84.5184C163.969 84.5184 156.464 77.0129 156.464 67.7544C156.464 58.4959 163.969 50.9905 173.228 50.9905C182.486 50.9905 189.992 58.4959 189.992 67.7544C189.992 77.0129 182.486 84.5184 173.228 84.5184Z",
    fill: "#EE4C2C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.1862724d640acf306a357d95ec5d42e7.svg";
export { ForwardRef as ReactComponent };